module.exports = __webpack_public_path__ + "static/media/gSablan.f32932a3.jpeg";